import { useCallback } from 'react';

import { useLogoImage } from '@app/hooks/useLogoImage';
import { FIELD_TYPES, validateFormFields } from '@app/utils/validateUtils';

import { GenericObject } from '@app/components/common/Table/DefaultTable/types';
import CreateView from '@app/components/common/views/CreateView';

import { CompanyForm } from './CompanyForm';

const formFields = [
  { key: 'logo', type: FIELD_TYPES.IMAGE, message: 'Logo is required' },
  { key: 'name', type: FIELD_TYPES.MULTILINGUAL, message: 'Name is required' },
  { key: 'preferred_name', type: FIELD_TYPES.MULTILINGUAL, message: 'Full name is required' },
  { key: 'short_name', type: FIELD_TYPES.MULTILINGUAL, message: 'Short name is required' },
  { key: 'industry_id', type: FIELD_TYPES.SELECT, message: 'Industry is required' },
];

const nonRequiredFields = [
  { key: 'description', emptyValue: '', isMultilingual: true },
  { key: 'twitter_handle', emptyValue: '', isMultilingual: false },
  { key: 'chix_symbol_id', emptyValue: 0 },
  { key: 'related_topic_ids', emptyValue: [] },
];

export const CreateCompany = () => {
  const { logoImage, handleChangeImageLogo, transform } = useLogoImage(nonRequiredFields);

  const validate = useCallback(
    (values: GenericObject) => validateFormFields({ fields: formFields, values, image: logoImage }),
    [logoImage]
  );
  return (
    <CreateView transform={transform} resourceSingular="company" validate={validate}>
      <CompanyForm companyLogo={logoImage} handleChangeCompanyLogo={handleChangeImageLogo} title="CREATE COMPANY" />
    </CreateView>
  );
};
